import React from 'react'
import { Button } from '@mc/design-system'
import { usePrimaryCta } from '@mc/growth'
import { useTranslation } from '@mc/i18n'
import classes from './ComingSoonEmailCapture.module.scss'

export const ComingSoonSignUp = ({
  onSubmit,
}: {
  onSubmit: (href: string) => void
}) => {
  const { t } = useTranslation('@mc/next')
  const { ctaHref } = usePrimaryCta()

  return (
    <div>
      <span className='mc-text--bold'>
        {t('sessions.campHeroCTAs.comingSoonSignUp.thankYou')}
      </span>
      <div className='d-flex no-gutters align-items-center mc-my-2'>
        <span className='col-8 mc-p-0 mc-mr-4 mc-text-small'>
          {t('sessions.campHeroCTAs.comingSoonSignUp.intro')}
        </span>
        <Button
          render={<a href={ctaHref} />}
          fullWidth
          onClick={() => onSubmit(ctaHref)}
        >
          <span className={classes.comingSoonCTAContent}>
            {t('sessions.campHeroCTAs.comingSoonSignUp.signUpCTA')}
          </span>
        </Button>
      </div>
    </div>
  )
}
